export const socialLinks = [
  {
    href: "#",
    className: "svg-icon svg-icon_facebook",
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    icon: "#icon_facebook",
  },
  {
    href: "#",
    className: "svg-icon svg-icon_twitter",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    icon: "#icon_twitter",
  },
  {
    href: "#",
    className: "svg-icon svg-icon_instagram",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    icon: "#icon_instagram",
  },
  {
    href: "#",
    className: "svg-icon svg-icon_pinterest",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    icon: "#icon_pinterest",
  },
];
